<template>
  <new-page-base>
    <template slot="titleLeft">
      Auditoria - Faturas
    </template>
    <template slot="titleRight">
      <router-link class="button is-primary" :to="{ name: 'billing-upload-page' }">
        Adicionar fatura
      </router-link>
      <router-link class="button" :to="{ name: 'create-billing-template' }">
        Criar novo modelo
      </router-link>
      <router-link class="button" :to="{ name: 'billing-my-files-page' }">
        Meus arquivos
      </router-link>
    </template>
    <section class="page-content">
      <billing-filter-area @onFilterChange="refreshValues"/>
      <billings-totalizers :totalizers="totalizers"/>
      <billings-by-lp-table
        :loading="loadingBillingsTable || this.$store.state.logisticProviders.loading"
        :billings="billingTableContent"/>
    </section>
  </new-page-base>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { ScButton } from '@intelipost-js/secure-components';
import NewPageBase from '../../components/new-page-base/NewPageBase';
import BillingFilterArea from './components/billing-filter-area/BillingFilterArea.vue';
import BillingsTotalizers from './components/billings-totalizers/BillingsTotalizers.vue';
import BillingsByLpTable from './components/billings-by-provider-table/BillingsByLPTable';

const { mapState, mapActions } = createNamespacedHelpers('recon/billing');

export default {
  name: 'PageBillingMain',
  methods: {
    ...mapActions(['loadBillingTotalizers', 'loadBillingsByLogisticProvider']),
    refreshValues({ dateRange, dateSource, warehouseFilter }) {
      const args = { dateRange, dateSource, warehouseIds: warehouseFilter };

      this.loadBillingTotalizers(args);
      this.loadBillingsByLogisticProvider(args);
    },
  },
  computed: {
    ...mapState(['totalizers', 'loadingBillingsTable', 'billingsByLogisticProvider']),
    billingTableContent() {
      if (this.$store.state.logisticProviders.loading) return [];
      return this.billingsByLogisticProvider;
    },
  },
  components: {
    ScButton,
    NewPageBase,
    BillingFilterArea,
    BillingsTotalizers,
    BillingsByLpTable,
  },
};

</script>
<style scoped lang="scss">
.page-content {
  margin-top: 3em;
}

.button {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/PageBillingMain.vue?874863ac